import React from 'react';
import { Box, Typography } from '@mui/material';

const DisplayContent = ({ type, info }) => {
  const containerSx = {
    width: '95%',
    maxWidth: '343px',
    height: '110px',
    border: '2px solid #ddd',
    borderRadius: '12px',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    boxSizing: 'border-box',
    fontFamily: 'Arial, sans-serif'
  };
  //console.log("DisplayContent type:", type, "info:", info);

  if (type === 'headerDisplay') {
    const { header, logo, text } = info;
    
    return (
      <Box sx={containerSx}>
        <Box sx={{
          textAlign: 'center',
          width: '100%'
        }}>
          {/* Header */}
          <Typography
            variant="h6"
            sx={{
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#333',
              marginBottom: '8px',
              letterSpacing: '1px'
            }}
          >
            {header}
          </Typography>
          
          {/* Logo and Text Row */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px'
          }}>
            {/* Logo */}
            {logo && (
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {typeof logo === 'string' ? (
                  <Box
                    component="img"
                    src={logo}
                    alt="Event logo"
                    sx={{
                      height: '40px',
                      width: 'auto',
                      maxWidth: '60px'
                    }}
                  />
                ) : (
                  <Box sx={{
                    width: '50px',
                    height: '40px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#666'
                      }}
                    >
                      {logo}
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
            
            {/* Text */}
            <Typography
              sx={{
                fontSize: '16px',
                color: '#666',
                fontWeight: '500'
              }}
            >
              {text}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  if (type === 'gameDisplay') {
    const { leftLogo, leftTeam, date, time, rightTeam, rightLogo } = info;
    
    return (
      <Box sx={containerSx}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}>
          {/* Left Team */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flex: '1'
          }}>
            {/* Left Logo */}
            {leftLogo && (
              typeof leftLogo === 'string' ? (
                <Box
                  component="img"
                  src={leftLogo}
                  alt={`${leftTeam} logo`}
                  sx={{
                    height: '32px',
                    width: '32px',
                    objectFit: 'contain'
                  }}
                />
              ) : (
                <Box sx={{
                  width: '32px',
                  height: '32px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Typography
                    sx={{
                      fontSize: '10px',
                      fontWeight: 'bold',
                      color: '#666'
                    }}
                  >
                    {leftLogo}
                  </Typography>
                </Box>
              )
            )}
            
            {/* Left Team Name */}
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}
            >
              {leftTeam}
            </Typography>
          </Box>

          {/* Center - Date/Time */}
          <Box sx={{
            textAlign: 'center',
            flex: '1',
            padding: '0 16px'
          }}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '2px'
              }}
            >
              {date}
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                color: '#666'
              }}
            >
              {time}
            </Typography>
          </Box>

          {/* Right Team */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flex: '1',
            justifyContent: 'flex-end'
          }}>
            {/* Right Team Name */}
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#333'
              }}
            >
              {rightTeam}
            </Typography>
            
            {/* Right Logo */}
            {rightLogo && (
              typeof rightLogo === 'string' ? (
                <Box
                  component="img"
                  src={rightLogo}
                  alt={`${rightTeam} logo`}
                  sx={{
                    height: '32px',
                    width: '32px',
                    objectFit: 'contain'
                  }}
                />
              ) : (
                <Box sx={{
                  width: '32px',
                  height: '32px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Typography
                    sx={{
                      fontSize: '10px',
                      fontWeight: 'bold',
                      color: '#666'
                    }}
                  >
                    {rightLogo}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      </Box>
    );
  }

  // Fallback for unknown type
  return (
    <Box sx={{...containerSx, backgroundColor: '#f8f8f8'}}>
      <Typography sx={{ textAlign: 'center', color: '#666' }}>
        Unknown display type: {type}
      </Typography>
    </Box>
  );
};

export default DisplayContent;